import { render, staticRenderFns } from "./groupRolePricingModal.vue?vue&type=template&id=52e8dc2a&scoped=true&"
import script from "./groupRolePricingModal.vue?vue&type=script&lang=js&"
export * from "./groupRolePricingModal.vue?vue&type=script&lang=js&"
import style0 from "./groupRolePricingModal.vue?vue&type=style&index=0&id=52e8dc2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e8dc2a",
  null
  
)

export default component.exports